// hide the details section by default if the number of activity items is greater than this value
export const NUM_ACTIVITY_ITEMS_TO_HIDE_DETAILS_SECTION = 1;

// hide activity items when there are more than this amount
export const HIDE_ACTIVITY_ITEMS_THRESHOLD = 5;

export const MAX_SHOW_MORE_ITEM_COUNT = 5;
